import React from "react";
import SummaryChannelByType from "components/Summary/SummaryChannelByType";
import Heading from "components/Elements/Heading";
import { Metric } from "components/Utils/Utils";

const SummaryChannelByTypeBreakouts = (props) => {
  const { metric, currentValue, table, graph } = props.data.data;

  return (
    <div className="row">
      <div className="col-12">
        <div className="row">
          <div className="col-12 mb-2">
            <Heading size={5} className={"mb-6"}>
              {metric.name}
            </Heading>
            <Metric {...currentValue} size={"lg"} />
          </div>
        </div>
      </div>
      <div className="col-12">
        <SummaryChannelByType data={table} graph={graph} />
      </div>
    </div>
  );
};

export default SummaryChannelByTypeBreakouts;
